import { Suspense, useEffect, useState } from "react"
import { Outlet } from "react-router-dom"
import { Sidebar } from "./Sidebar"
import { TopBar } from "./TopBar"
import { CommandPalette } from "./CommandPalette"
import { TooltipProvider } from "@/components/ui/tooltip"
import { LoadingSpinner } from "@/components/shared"

/** localStorage-Schlüssel für den Einklapp-Zustand der Sidebar (pro App anpassen). */
const COLLAPSED_STORAGE_KEY = "rmnc-personal.sidebar.collapsed"

export function MainLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(COLLAPSED_STORAGE_KEY) === "1"
    } catch {
      return false
    }
  })
  const [paletteOpen, setPaletteOpen] = useState(false)

  // Einklapp-Zustand über Reloads hinweg merken (UX_KONZEPT §1.2: Teil des Shell-Musters).
  useEffect(() => {
    try {
      localStorage.setItem(COLLAPSED_STORAGE_KEY, sidebarCollapsed ? "1" : "0")
    } catch {
      /* Privacy-Mode: Zustand bleibt in-memory */
    }
  }, [sidebarCollapsed])

  // Globaler Hotkey ⌘K (Mac) / Strg-K (Win/Linux) — Toggle der Palette.
  useEffect(() => {
    function handler(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault()
        setPaletteOpen((open) => !open)
      }
    }
    window.addEventListener("keydown", handler)
    return () => window.removeEventListener("keydown", handler)
  }, [])

  return (
    <TooltipProvider>
      <div className="flex h-screen flex-col overflow-hidden bg-background">
        {/* Einzige Kopfleiste der Shell (UX_KONZEPT §1.2, konsolidiert) */}
        <TopBar
          onOpenPalette={() => setPaletteOpen(true)}
          onToggleSidebar={() => setSidebarCollapsed((c) => !c)}
        />

        <div className="flex flex-1 overflow-hidden">
          <Sidebar collapsed={sidebarCollapsed} />

          <div className="flex flex-1 flex-col overflow-hidden">
            <main className="flex-1 overflow-auto p-6">
              <Suspense fallback={<LoadingSpinner fullPage />}>
                <Outlet />
              </Suspense>
            </main>
          </div>
        </div>
      </div>

      <CommandPalette open={paletteOpen} onOpenChange={setPaletteOpen} />
    </TooltipProvider>
  )
}
